import React from 'react';
import { motion } from 'framer-motion';
import { Check } from 'lucide-react';
import { Button } from './Button';
import { everythingIncluded, noMore } from '../data/includes';
import { CHECKOUT_URL, trackInitiateCheckout } from '../utils/tracking';
export function FinalCTA() {
  return <section className="py-24 px-4 bg-terracotta-deep text-paper" data-id="element-96" data-mp="85fc0zc93r28">
      <div className="max-w-4xl mx-auto" data-id="element-97" data-mp="87a20s2dq9d6">
        <div className="text-center mb-16" data-id="element-98" data-mp="m4f5qlemew59">
          <p className="text-paper/70 font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-99" data-mp="m340si9fvick">
            Your Next Working Week
          </p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-3xl md:text-5xl font-serif font-bold mb-8 leading-tight" data-id="element-100" data-mp="vui2mwov4u8v">
            You can spend the next few days continuing to build your sessions
            from scratch...
            <br data-id="element-101" data-mp="2h5ko3zpns3nr" />
            <span className="text-[#F2C9A8]" data-id="element-102" data-mp="2m342czmcwgfp">
              Or you can start your next working week with a complete
              professional system already prepared.
            </span>
          </motion.h2>

          <ul className="max-w-2xl mx-auto text-left space-y-4 mb-12 bg-white/10 p-8 rounded-2xl border border-paper/20" data-id="element-103" data-mp="2v4275k4mcrzc">
            {noMore.map(item => <li key={item} className="flex items-start gap-3" data-id="element-104" data-mp="300itq9w66yab">
                <span className="text-[#F2C9A8] mt-1" aria-hidden="true" data-id="element-105" data-mp="34un30zswriek">
                  ✦
                </span>
                <span className="text-paper/90" data-id="element-106" data-mp="39rvk0x2blge8">{item}</span>
              </li>)}
          </ul>

          <p className="text-xl mb-2" data-id="element-107" data-mp="3etck4qczcytr">
            Massage Therapist Ready does not make you a massage therapist.
          </p>
          <p className="text-2xl font-bold text-[#F2C9A8] mb-6" data-id="element-108" data-mp="1joczyjhcj9z6">
            You're already the professional.
          </p>
          <p className="text-xl text-paper/90" data-id="element-109" data-mp="1eq1oy5fbetfd">
            What Massage Therapist Ready does is give you the structure,
            resources, and professional system to put your knowledge into action
            more consistently.
          </p>
        </div>

        <div className="bg-paper text-charcoal rounded-3xl p-8 md:p-12" data-id="element-110" data-mp="1no3umy9zua8z">
          <h3 className="text-2xl font-bold mb-6 text-center border-b border-warmgray pb-6" data-id="element-111" data-mp="22d9vsrse6aji">
            Everything Included
          </h3>

          <ul className="grid md:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-id="element-112" data-mp="2bf9bngro78kv">
            {everythingIncluded.map(item => <li key={item} className="flex items-center gap-3" data-id="element-113" data-mp="27do2a5echcff">
                <Check size={18} className="text-terracotta shrink-0" aria-hidden="true" data-id="element-114" data-mp="h1i54q4n14tn" />
                <span className="text-sm text-charcoal-soft" data-id="element-115" data-mp="d1hem749l368">{item}</span>
              </li>)}
          </ul>

          <div className="text-center" data-id="element-116" data-mp="2y2ngl0q472m">
            <div className="mb-8 p-6 bg-sand rounded-xl border border-warmgray italic text-charcoal-soft text-lg" data-id="element-117" data-mp="6y31i4jwug95">
              "The best time to have a complete professional system was before
              the last session you had to improvise.
              <br data-id="element-118" data-mp="3u8t0rqjofxhj" />
              <span className="text-terracotta-deep font-bold not-italic" data-id="element-119" data-mp="3u8aue13aw2vw">
                The second best time is before your next client.
              </span>
              "
            </div>

            <p className="text-xl font-serif font-bold mb-2" data-id="element-120" data-mp="3ka3frowhhwx2">
              Massage Therapist Ready
            </p>
            <p className="text-sm text-charcoal-muted mb-8" data-id="element-121" data-mp="3bbrodknsmv3k">
              7 complete professional volumes, 150 ready-to-use massage
              sessions, and 5 exclusive bonuses created to help massage
              therapists plan less, work with more confidence, and bring more
              structure to every appointment.
            </p>

            <Button href={CHECKOUT_URL} target="_blank" onLinkClick={trackInitiateCheckout} className="w-full md:w-auto text-lg md:text-xl py-5 px-10 mb-6 bg-burnt-light hover:bg-terracotta-dark" data-id="element-122" data-mp="35m8dqu9zwtze">
              GET MASSAGE THERAPIST READY NOW
            </Button>

            <div className="flex flex-wrap justify-center gap-4 text-xs text-charcoal-muted" data-id="element-123" data-mp="2rq4kp4auyroi">
              <span data-id="element-124" data-mp="2mqrzsp3jruok">7-Day Money-Back Guarantee</span>
              <span data-id="element-125" data-mp="2hwxj7uj8nvtp">·</span>
              <span data-id="element-126" data-mp="2hwnra1emveld">Instant Digital Access</span>
              <span data-id="element-127" data-mp="2cychfqoc9435">·</span>
              <span data-id="element-128" data-mp="2czx8v7fcw6ws">One-Time Payment</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}